import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Lock } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function MockCheckoutDialog({ checkout, onClose, onSuccess }) {
  const [form, setForm] = useState({ card_number: "4111 1111 1111 1111", card_name: "", expiry: "12/28", cvv: "123" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const pay = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post(`/subscriptions/checkout/${checkout.checkout_id}/confirm-mock`, { card_number: form.card_number, card_name: form.card_name, expiry: form.expiry });
      onSuccess(data);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!checkout} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="mock-checkout-dialog" className="sm:max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><span className="w-8 h-8 rounded-lg grid place-items-center text-white text-xs font-bold" style={{ background: "#0C2451" }}>R</span> Razorpay Checkout <span className="text-xs font-mono px-2 py-0.5 rounded bg-amber-100 text-amber-800">TEST / MOCK</span></DialogTitle>
          <DialogDescription>
            CG Land Geoportal Premium · ₹{checkout?.amount_inr}/month. {checkout?.trial_eligible ? "Your 7-day trial starts today — ₹0 charged now." : "Trial already used — you will be charged now."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={pay} className="space-y-4 mt-2">
          <div className="space-y-2"><Label>Card number</Label><Input data-testid="checkout-card-number-input" value={form.card_number} onChange={set("card_number")} required className="font-mono h-11 rounded-xl" /></div>
          <div className="space-y-2"><Label>Name on card</Label><Input data-testid="checkout-card-name-input" value={form.card_name} onChange={set("card_name")} required minLength={2} placeholder="As printed on card" className="h-11 rounded-xl" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2"><Label>Expiry</Label><Input data-testid="checkout-card-expiry-input" value={form.expiry} onChange={set("expiry")} required placeholder="MM/YY" className="font-mono h-11 rounded-xl" /></div>
            <div className="space-y-2"><Label>CVV</Label><Input data-testid="checkout-card-cvv-input" value={form.cvv} onChange={set("cvv")} required type="password" className="font-mono h-11 rounded-xl" /></div>
          </div>
          <p className="text-xs text-muted-foreground">Mock gateway: any card works; cards ending in <span className="font-mono">0000</span> are declined. One trial per card.</p>
          <Button data-testid="checkout-pay-button" type="submit" disabled={loading} className="w-full h-11 rounded-full font-semibold text-white hover:opacity-90" style={{ background: "#0C2451" }}>
            <Lock size={14} className="mr-2" />{loading ? "Processing…" : checkout?.trial_eligible ? "Start 7-day trial" : `Pay ₹${checkout?.amount_inr}`}
          </Button>
          <p className="text-[11px] text-center text-muted-foreground flex items-center justify-center gap-1"><CreditCard size={11} /> Secured by Razorpay (simulated)</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
